import React from 'react';
import { Link } from 'react-router-dom';
import ButtonFilter from '../Filter';
import {isMobile} from 'react-device-detect';
import './Card.scss';

function Card(props) {
  const { title, subtitle1, subtitle2, filter, link, linkPosition, dropdown } = props;
  return (
    <div className="card">
      <div className="card-content" style={{padding: isMobile? '24px 16px': '24px'}}>
        {filter && <ButtonFilter dropdown={dropdown && dropdown} />}

        <p className="title title-22">{title}</p>
        <div style= {{display: 'flex', flexWrap: 'wrap'}}>
          <span className="title title-16 title-gray">{subtitle1}</span>
          {subtitle2 && <span className="title title-16 title-mint">{subtitle2}</span>}
        </div>
        {props.children}

        {link && (
          <div className={`link-${linkPosition}`}>
            {link}
            {/* <Link to={link.path} className={`link-${linkPosition}`}>
            {link.name}
          </Link> */}
          </div>
          
        )}
      </div>
    </div>
  );
}

export default Card;
